/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { datePickerMinDate, linkPattern, noWhitespaceInRequiredValidator, password_validation } from '../../../shared/constants';
import { noop } from 'jquery';
import { addDays } from 'date-fns';
import { NavbarComponent } from '../../../navbar/navbar.component';

@Component({
	selector: 'app-event-form',
	templateUrl: './event-form.component.html',
	styleUrl: './event-form.component.scss'
})
export class EventFormComponent {
	moduleForm: FormGroup = this.formBuilder.group({
		name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		date: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		departments: [null],
		users: [null],
		presenter_departments: [null],
		presenter_users: [null]
	});
	showLoader = false;
	pageLoading1 = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	formSubmitted = false;
	details: any = null;
	minDate = datePickerMinDate;
	userList: any[] = [];
	allUserList: any[] = [];
	presenter_userList: any[] = [];
	presenter_allUserList: any[] = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.apiService.userList$.subscribe((userList) => {
			if (userList) {
				this.allUserList = userList.filter((u) => u.emp_code);
				this.presenter_allUserList = userList.filter((u) => u.emp_code);
				this.getUserList();
				this.presenter_getUserList();
			}
		});
	}

	getUserList() {
		const departments = this.f.departments.value;
		if (departments && departments.length) {
			this.userList = this.allUserList.filter((u) => departments.find((d) => d == u.department));
		} else {
			this.userList = this.allUserList.filter((u) => true);
		}
	}

	presenter_getUserList() {
		const presenter_departments = this.f.presenter_departments.value;
		if (presenter_departments && presenter_departments.length) {
			this.presenter_userList = this.presenter_allUserList.filter((u) => presenter_departments.find((d) => d == u.department));
		} else {
			this.presenter_userList = this.presenter_allUserList.filter((u) => true);
		}
	}

	initForm(uId: any) {
		this.uId = uId;
		if (this.uId) {
			this.getDetails();
		} else {
			this.moduleForm.reset();
			this.formSubmitted = false;
			this.uId = null;
		}
	}

	get f() { return this.moduleForm.controls; }

	clearForm() {
		this.uId = null;
		this.moduleForm.reset();
		this.formSubmitted = false;
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getEvent({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.details = data;
				this.f.name.setValue(this.details.name);
				this.f.departments.setValue(this.details.departments);
				this.f.presenter_departments.setValue(this.details.presenter_departments);
				this.f.users.setValue(this.details.users);
				this.f.presenter_users.setValue(this.details.presenter_users);
				this.f.date.setValue(this.apiService.getDateFromDateString(this.details.date, 'DD-MM-YYYY'));
				this.getUserList();
				this.presenter_getUserList();
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
					noop;
				}
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			name: this.f.name.value,
			date: this.apiService.getDateStringFromDate(this.f.date.value, 'YYYY-MM-DD'),
			presenter_departments: this.f.presenter_departments.value,
			presenter_users: this.f.presenter_users.value
		};
		if (this.uId) {
			data.id = this.uId;
			data.departments = this.f.departments.value;
			data.users = this.f.users.value;
		}
		this.showLoader = true;
		this.apiService.createUpdateEvent(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
